import { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { PiHandshakeDuotone } from "react-icons/pi";

import mc1 from './../media/img/mc1.jpg'
import mc2 from './../media/img/mc2.jpg'
import mc3 from './../media/img/mc3.jpg'
import mc4 from './../media/img/mc4.jpg'
import mc5 from './../media/img/mc5.jpg'
import mc6 from './../media/img/mc6.jpg'
import mc7 from './../media/img/mc7.jpg'
import mc8 from './../media/img/mc8.jpg'
import mc9 from './../media/img/mc9.jpg'
import mc10 from './../media/img/mc10.jpg'
import mc11 from './../media/img/mc11.jpg'
import mc12 from './../media/img/mc12.jpg'
import mc13 from './../media/img/mc13.jpg'
import mc14 from './../media/img/mc14.jpg'
import mc15 from './../media/img/mc15.jpg'
import mc16 from './../media/img/mc16.jpg'
import mc17 from './../media/img/mc17.jpg'
import mc18 from './../media/img/mc18.jpg'
import mc19 from './../media/img/mc19.jpg'
import mc20 from './../media/img/mc20.jpg'
import mc21 from './../media/img/mc21.jpg'
import mc22 from './../media/img/mc22.jpg'
import mc23 from './../media/img/mc23.jpg'
import mc24 from './../media/img/mc24.jpg'
import mc25 from './../media/img/mc25.jpg'
import mc26 from './../media/img/mc26.jpg'


import sui_ai_logo from './../media/img/sui_ai_logo.webp'
import x_logo from './../media/img/x-logo.png'
import tg_logo from './../media/img/tg-logo.png'
import dex_logo from './../media/img/dex-logo.png'
import phantom_logo from './../media/img/phantom_logo.png'
import sol_logo from './../media/img/sol_logo.png'
import sui_wallet from './../media/img/suiwallet.png'
import sui_coin from './../media/img/suicoin.png'
import move_logo from './../media/img/move-logo.png'
import dex_s_logo from './../media/img/dex_s_logo.png'
import gk_logo from './../media/img/gk_logo.png'
import cg_logo from './../media/img/cg_logo.png'

import ton_logo from './../media/img/tn-logo-bg.png'
import ton_keeper_logo from './../media/img/tonkeeper_logo.png'
import { ReactComponent as BscLogo } from './../media/img/bscscan-logo.svg';

import x_icon from './../media/icons/x-icon.png'
import twitter_icon from './../media/icons/twitter-icon.jpg'
import tg from './../media/icons/tg-icon.png'

import com_icon from './../media/icons/com_icon.png'
import ama_icon from './../media/icons/ama_icon.png'
import inf_icon from './../media/icons/inf_icon.png'
import earn_icon from './../media/icons/earn_icon.png'
import check_icon from './../media/icons/check_icon.png'
import eq_icon from './../media/icons/eq_icon.png'
import lock_icon from './../media/icons/lock_icon.png'
import per_icon from './../media/icons/per_icon.png'
import copy_icon from './../media/icons/copy.png'
import angle_down from './../media/icons/angle_down.png'

import mail_icon from './../media/icons/mail-icon.png'
import dex_icon from './../media/icons/dex-icon.png'

import { htws } from './../utilities/about-htw'
import { jeetcmds } from './../utilities/jeet-cmd'


const Home = () => {

    const womItems = [ {fileLink: mc2},{fileLink: mc4},{fileLink: mc5},{fileLink: mc6},{fileLink: mc7},{fileLink: mc8},{fileLink: mc9},{fileLink: mc10},{fileLink: mc1},{fileLink: mc3}, ]

    const [htwCount, setHtwcount] = useState(0)
    const [textca, setTextca] = useState("A5qoJwvYZMRYhQFYSczRduvc9VwWAXYSYnH4wVxUVRCs");

    const [pause, setPause] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        let scrollInterval;
    
        const startScrolling = () => {
          scrollInterval = setInterval(() => {
            if (!pause) {
              container.scrollLeft += 1;
              if (container.scrollLeft >= container.scrollWidth - container.clientWidth) {
                container.scrollLeft = 0; // reset to the beginning
              } else {
                container.scrollLeft += 1; // Continue scrolling
              }
            }
          }, 20);
        };

        startScrolling();

        return () => clearInterval(scrollInterval);
    }, [pause]);

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(textca)
      .then(() => {
        alert("ca copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy ca: ", err);
      });
  };



    return ( 
        <div className="">

            <section id="home" className="home">
                <div className="main-frame">
                    <div className="flex align-center home-frame">

                        <div className="home-text flex justify-center">
                            <div className="home-text-inner">
                                <div className="home-head-subhead">
                                    <h3 className="text-align-center">
                                        Welcome to Merica
                                    </h3>
                                    <h2 className="text-align-center">FREEDOM AND CRYPTO.</h2>
                                </div>

                                <div className="flex row wrap justify-center gap-15 hm-btn-cont">
                                    <a href="https://t.me/DEGEN_MERICA" target="_blank" className='btn-1'>
                                        Community
                                    </a>
                                    <a href="https://jup.ag/swap/SOL-A5qoJwvYZMRYhQFYSczRduvc9VwWAXYSYnH4wVxUVRCs" target="_blank" className='btn-1 sup'>
                                        New Buy $MERICA
                                    </a>
                                    <a href="#roadmap" target="_blank" className='btn-1'>
                                        Road map
                                    </a>
                                </div>
                                
                                <div className="flex justify-center">
                                    <div className="flex row align-center justify-space-between gap-5 copy-address-box">
                                        {/* <img src={copy_icon} alt="" onClick={copyToClipboard} /> */}
                                        <p>A5qoJwvYZMRYhQFYSczRdu...</p>
                                        <div className="copy-btn-box flex justify-center align-center cursor-pointer" onClick={copyToClipboard}>
                                            <h5 className="">Copy Address</h5>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex row gap-15 mgb-30" data-aos="fade-left" data-aos-duration="2000">
                                    {/* <a href="https://x.com/lokaisui" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={x_logo} alt="" />
                                    </a>
                                    <a href="https://t.me/LOKAISui" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={tg_logo} alt="" />
                                    </a>
                                    <a href="https://suiai.fun/pool/0x23d9137bb1bb78bbca8296fe4ef698830c486b91e1dc714d70c997b3caa94780" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={sui_ai_logo} alt="" />
                                    </a> */}
                                    {/* <a href="" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={dex_s_logo} alt="" />
                                    </a>
                                    <a href="" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={cg_logo} alt="" />
                                    </a>
                                    <a href="" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={gk_logo} alt="" />
                                    </a> */}
                                </div>
                            </div>
                        </div>

                        {/* <div className="home-img"> */}
                            {/* <img src={las4_nb} alt="" /> */}
                        {/* </div> */}

                    </div>
                </div>
            </section>

            <section className="about" id="about">
                <div className="main-frame">
                    <div className="flex row wrap align-center">
                        <div className="about-img">
                            <img src={mc26} alt="" />
                        </div>

                        <div className="about-text">
                            {/* <h2>About Peki Inu</h2> */}
                            <h3>$MERICA</h3>
                            <p>                                
                                Land of the free, home of the degen! 🇺🇸💥 $MERICA is where freedom and crypto collide, bringing unstoppable energy to the blockchain. 
                                Inspired by the spirit of independence and powered by the people, $MERICA is more than a token, it’s a movement. Built for those 
                                who believe in decentralization, financial freedom, and sending it to the moon, $MERICA is here to make crypto great again! 🚀🔥
                            </p>

                            {/* <a href="https://x.com/babylofitheyeti" className="about-btn flex row gap-15 justify-center align-center">
                               <span>Check out Tweet</span> 
                               <img src={twitter_icon} alt="" />
                            </a> */}
                        </div>
                    </div>
                </div>
            </section>

            <section className="tk" id="tk">
                <div className="htb-frame">
                    <div className="cs-header" data-aos="fade-up" data-aos-duration="2000">
                        <h2>TOKENOMICS</h2>
                    </div>
                    <div className="grid grid-column-4 row grid-column-gap-50 grid-row-gap-20" >

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={check_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Name/Ticker</h2>
                                <h3>$MERICA</h3>
                            </div>
                        </div>

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={eq_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Total Supply</h2>
                                <h3>1,000,000,000</h3>
                            </div>
                        </div>

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={lock_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>LP Burned</h2>
                                <h3>Liquidity is burned forever</h3>
                            </div>
                        </div>

                        <div className="tk-item" data-aos="fade-right" data-aos-duration="2000">
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={per_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Taxes</h2>
                                <h3>1/1</h3>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="roadmap" id="roadmap">
                <div className="effect-wrap">
                    <div className="effect rd-effect-1">
                        <img src={mc22} alt="" />
                    </div>
                    <div className="effect rd-effect-2">
                        <img src={mc4} alt="" />
                    </div>
                    <div className="effect rd-effect-3">
                        <img src={mc6} alt="" />
                    </div>
                    <div className="effect rd-effect-4">
                        <img src={mc10} alt="" />
                    </div>
                </div>
                <div className="cs-header">
                    <h2>THE ROADMAP</h2>
                </div>
                <div className="wrapper">
                    <div className="center-line">
                        <div className="scroll-icon"></div>
                    </div>
                    <div className="timeline-row row-1">
                        <section>
                            <i className="icon fas fa-home"></i>
                            <div className="details">
                                <span className="title">Phase 1:</span>
                            </div>
                            <h3>LAUNCH</h3>
                            <ul>
                                <li>Stealth Launch.</li>
                                <li>First steps on marketing strategy.</li>
                                <li>Social Media Creation.</li>
                                <li>Website Creation.</li>
                                <li>NFT first concepts.</li>
                                <li>Launchpad creation on Pinksale.</li>
                            </ul>
                        </section>
                    </div>
                    <div className="timeline-row row-2">
                        <section>
                            <i className="icon fas fa-star"></i>
                            <div className="details">
                                <span className="title">Phase 2:</span>
                            </div>
                            <h3>PROGRESSION</h3>
                            <ul>
                                <li>First AMA session.</li>
                                <li>First NFT batch release.</li>
                                <li>CMC & CG Listing.</li>
                                <li>First donation event.</li>
                                <li>First marketing wave.</li>
                                <li>Website Redesign.</li>
                            </ul>
                        </section>
                    </div>
                    <div className="timeline-row row-1">
                        <section>
                            <i className="icon fas fa-map-marker-alt"></i>
                            <div className="details">
                                <span className="title">Phase 3</span>
                            </div>
                            <h3>DIVERSIFICATION</h3>
                            <ul>
                                <li>Continued NFT releases.</li>
                                <li>Second donation event.</li>
                                <li>Further development updates.</li>
                                <li>Staking platform development.</li>
                                <li>Ecosystem updates.</li>
                            </ul>
                        </section>
                    </div>
                </div>
            </section>

            <section className="wom" id="wom">
                <div className="cs-header">
                    <h2>Merica Memes</h2>
                </div>
                <div
                    className="cards-container"
                    ref={containerRef}
                    onMouseEnter={() => setPause(true)}
                    onMouseLeave={() => setPause(false)}
                >
                    {womItems ? womItems.map((womItem, index) => (
                        <div key={index} className="card">
                            {/* <h3>Card {index + 1}</h3> */}
                            {/* <p>This is a sample card content.</p> */}
                            <div className="wom-image-box">
                                <img src={womItem.fileLink} alt="" />
                            </div>
                        </div>
                    )) : null}
                </div>
            </section>

            {/* <section className="roadmap" id="roadmap">
                <div className="main-frame">
                    <div className="roadmap-header" data-aos="fade-up" data-aos-duration="2000">
                        <h3>ROADMAP $MERICA</h3>
                    </div>

                    <div className="roadmap-item-cont grid grid-column-3 grid-column-gap-25 grid-row-gap-10 overflow-y-hidden">
                        <div className="rd-item">
                            <h2>Phase 1: Launch</h2>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> 
                                <p><span>Stealth Launch</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> 
                                <p><span>Low Starting Liquidity Pool</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> 
                                <p><span>Low Starting Market Cap</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> 
                                <p><span>Liquidity Pool Locked at Launch</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"><img src={check_icon} alt="" /></div> 
                                <p><span>Website Launch</span></p>
                            </div>
                        </div>

                        <div className="rd-item">
                            <h2>Phase 2: Growth</h2>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>Reserved Supply for Listings</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>Community-Driven Growth</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>Future Utilities</span></p>
                            </div>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>Meme Culture Expansion</span></p>
                            </div>
                        </div>

                        <div className="rd-item">
                            <h2>Phase 3: stay tuned</h2>
                            <div className="flex row gap-10 rd-list-box">
                                <div className="flex justify-center align-center"></div> 
                                <p><span>LOCKED - complete PHASE2</span></p>
                            </div>
                        </div>

                    </div>
                </div>
            </section> */}

            {/* <section className="join" id="join">
                <div className="kf-frame">
                    <div className="cs-header overflow-y-hidden" data-aos="fade-up" data-aos-duration="2000">
                        <h2>BabyLOFI the little Yeti!</h2>
                    </div>

                    <div className="join-box">
                        <div className="flex justify-center overflow-y-hidden">
                            <img src={bl1} alt="" />
                        </div>
                        <p>
                            🚀 Join the Revolution: Welcome to the Community of SUI Degens! 🚀 <br /><br />

                            Baby Lofi is the adorable and mischievous son of #Lofi the Yeti, the legendary YETI of the #Sui Chain.💧 <br /><br />

                            Baby Lofi carries the same playful spirit and determination as his father, but with his own unique charm and charisma! <br /><br />

                            🌌 The future is here. Be part of it. 🌌
                        </p>
                        <h4>CA: 0x1e8f1b2d8ccb15f78562ab6ed05fc477d58f9cd46a355d13fbcc2f9a7ce27023::babylofi::BABYLOFI</h4>
                        <a href="https://t.me/BabyLofiOnSUI" target="_blank" className="btn-1">Telegram</a>
                    </div>
                </div>
            </section> */}

            {/* <section className="footer" id="footer">
                <div className="main-container">
                    
                        <div className="footer-box ">
                            <h2>$MERICA</h2>
                            <div className="flex justify-center">
                                <div className="flex row gap-15 mgb-30">
                                    <a href="https://x.com/lokaisui" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={x_logo} alt="" />
                                    </a>
                                    <a href="https://t.me/LOKAISui" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={tg_logo} alt="" />
                                    </a>
                                    <a href="https://dexscreener.com/solana/hltyys5nr9kcubxknfmu1cushhnsn1cajrjfdj7n1bwq" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={dex_logo} alt="" />
                                    </a>
                                </div>
                            </div>
                            <p className="copyright">MERICA copyright 2024 - All Rights Reserved</p>
                    </div>

                </div>
            </section> */}

            <section className="contact" id="contact">
                <div className="main-frame">
                    <div className="row">
                        <div className="contact-content-1">
                            <h2>stay connected to $MERICA</h2>
                            <h3>stay updated and join the $MERICA family</h3>
                            <div className="social-btns-container">
                                <div className="social-btn-item">
                                    <a target="_blank" href="https://x.com/degen_merica?s=21">
                                        <center>
                                            <div className="social-icon-container flex justify-center align-center">
                                                <img src={x_logo} alt="" />
                                            </div>
                                        </center>
                                        <div className="flex row gap-5 social-icon-no">
                                            <h5>70k</h5>
                                            <img src={angle_down} alt="" />
                                        </div>
                                    </a>
                                </div>
                                <div className="social-btn-item">
                                    <a href="https://t.me/DEGEN_MERICA" target="_blank">
                                        <center>
                                            <div className="social-icon-container flex justify-center align-center">
                                                <img src={tg_logo} alt="" />
                                            </div>
                                        </center>
                                        <div className="flex row gap-5 social-icon-no">
                                            <h5>70k</h5>
                                            <img src={angle_down} alt="" />
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="contact-content-2">
                            <div className="contact-content-item-1">
                                <img src={mc3} alt="" />
                                <p>
                                    Copyright © $MERICA 2025.<br />All rights reserved.
                                </p>
                            </div>
                            <div className="contact-content-item-2">
                                <h2>price info</h2>
                                <a href="https://jup.ag/swap/SOL-A5qoJwvYZMRYhQFYSczRduvc9VwWAXYSYnH4wVxUVRCs">Jupiter</a><br /><br />
                                <a href="https://dexscreener.com/solana/3gmegvbrmydtarphkqdbwqcpnngztcvcbpkxnokqvl1n" target="_blank">Dexscreener</a>
                            </div>
                            <div className="contact-content-item-2">
                                <h2>socials</h2>
                                <a target="_blank" href="https://t.me/DEGEN_MERICA"> Telegram</a>
                                <a target="_blank" href="https://x.com/degen_merica?s=21"> Twitter</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}
 
export default Home;